const __WEBPACK_NAMESPACE_OBJECT__ = require("html-webpack-plugin");